import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { paymentMethodApi } from '../services/paymentMethodApi';

export function useSavedCards() {
  const query = useQuery({
    queryKey: ['saved-payment-methods'],
    queryFn: () => paymentMethodApi.list(),
    staleTime: 60_000,
  });

  return {
    cards: query.data?.payment_methods ?? [],
    defaultPaymentMethodId: query.data?.default_payment_method_id ?? null,
    isLoading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
}

export function useSavedCard() {
  const { cards, defaultPaymentMethodId, ...rest } = useSavedCards();
  const defaultCard = cards.find((card) => card.id === defaultPaymentMethodId) ?? cards[0] ?? null;

  return {
    card: defaultCard,
    cards,
    defaultPaymentMethodId,
    ...rest,
  };
}

export function useRemoveSavedCard() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (paymentMethodId: string) => paymentMethodApi.remove(paymentMethodId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['saved-payment-methods'] });
    },
  });
}

export function useSetDefaultSavedCard() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (paymentMethodId: string) => paymentMethodApi.setDefault(paymentMethodId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['saved-payment-methods'] });
    },
  });
}
